let PurposeTree = require('../purpose-tree');
let LegalTree = require('../legal-tree');

class Discount {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        let props = this.$context.props;
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, props));
    }
}

module.exports = {
    constructor: Discount,
    children: [
        {
            name: 'purpose-tree',
            component: PurposeTree,
            watcher: {
                isShowed: ['order', 'computed', 'exportColumns', 'byPropertyName', 'Purpose', 'isChecked']
            },
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            }
        },
        {
            name: 'legal-tree',
            component: LegalTree,
            watcher: {
                isShowed: ['order', 'computed', 'exportColumns', 'byPropertyName', 'LegalForm', 'isChecked']
            },
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/common/custom-order/additional-parameters/content/filter-multicolumn/index.js